import { useEffect, useState, useRef } from "react";
import { getToken, getUserId } from "../../../auth";
import funzione_collegamento from "../../../funzioni_server/pacchetti_lez_function.js";
import lezioni from "../../../funzioni_server/lesson_function.js";
import convertDate from "../../../funzioni/converti_data";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faUsers,faFileArrowDown, faLock,faPencil, faTrashCan,faCircleInfo,faSpinner } from "@fortawesome/free-solid-svg-icons";
import "../../../stili/tabelle.css";
import ReactDOM from "react-dom/client";
import "../../../stili/popup.css";
import  nome_id  from "../../../funzioni/nome_id";
import  status_lezione  from "../../../funzioni/status_lezione";
import  differenzaOrario  from "../../../funzioni/differenza_ore";
import { DateTime } from 'luxon';
import {decodificaExtra,istruttori_disponibili,aggiungiTempo,convertiValuta,criptaRuolo,decriptaRuolo} from "../../../funzioni/funzioni_utili"
import {createLetter } from "../../../funzioni/creazione_file"
import Lottie from "lottie-react";
import animLoading from "../../../assets/loading.json";
import animLoading2 from "../../../assets/loading2.json";
/* global $ */
const PaginaPrenotazioni =() =>{
function mostraOpzioni(pacchetto){
    const contenuto =document.createElement("div")
    const isMobile = window.innerWidth <= 768; // soglia tipica
    if (!isMobile){
    Object.assign(contenuto.style, {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between"
});}
    const pulsanteSalva=document.createElement("div")
    pulsanteSalva.id="pulsanteSalva"
    const pulsanteChiudi=document.createElement("div")
    contenuto.appendChild(pulsanteSalva)
    contenuto.appendChild(pulsanteChiudi)

    pulsanteChiudi.id="pulsanteChiudi"
    setTimeout(()=>{
        $("#pulsanteSalva").dxButton({
        text: "Scarica lettera",
  type: "default",
  icon: "download",
  onClick: async function (e){
    const camere=await funzione_collegamento({
    userid: getUserId(),
    token: getToken(),
    logout_on_error: true,
    azione:"getLinkBookingRooms",
    filtri: { bookingid: pacchetto.bookingid,},
  });
    const ospiti=await funzione_collegamento({
    userid: getUserId(),
    token: getToken(),
    logout_on_error: true,
    azione:"getBookingGuests",
    filtri: { bookingid: pacchetto.bookingid,},
  });
  let ospiti_preno=[]
  for (let camera of camere){
    for (let ospite of ospiti){
        if (ospite.linkbookroomid===camera.linkbookroomid){
            ospiti_preno.push({Nome:ospite.guestname,Cognome:ospite.guestsurname,"Numero di documento":ospite.guestdocnumber})
        }
    }
  }
    const data=[{ "Check-In": DateTime.fromISO(pacchetto.checkin).toFormat("dd/MM/yyyy"), "Check-Out": DateTime.fromISO(pacchetto.checkout).toFormat("dd/MM/yyyy") }]

    const pdfBlob = await createLetter(data, ospiti_preno);
    const url = URL.createObjectURL(pdfBlob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `BookingConfirmation_${ospiti_preno[0].Cognome}.pdf`;
    a.click();
    URL.revokeObjectURL(url);
  }
  })
  $("#pulsanteChiudi").dxButton({
        text: "Scarica fattura",
  type: "normal",
  icon: "download",
  })
    },0)
    $("#scaricaFile").dxPopup("instance").option( "title",`Vuoi scaricare la lettera di conferma o la fattura di ${pacchetto.nome}?`);
    $("#scaricaFile").dxPopup("instance").option("contentTemplate", () => contenuto);
    $("#scaricaFile").dxPopup("instance").option( "toolbarItems", [ {
      widget: 'dxButton',
      toolbar: 'bottom',
      location: 'after',
      options: {
        text: 'Chiudi',
        stylingMode: 'outlined',
        type: 'normal',
        onClick() {
          $("#scaricaFile").dxPopup("instance").hide();
        },
      },
    }],)
    $("#scaricaFile").dxPopup("instance").show();
}
function truncate(num, decimals) {
  const factor = Math.pow(10, decimals);
  return Math.trunc(num * factor) / factor;
}
function DynamicLessonButton({ cellInfo, }) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    $("#loadingOverlay").show();
     setLoading(true);

          const content = await mostraPopupInfoLezione(
            cellInfo.data.bookingid,cellInfo.data.nome
          );

          $("#loadingOverlay").hide();  // Nasconde overlay
            setLoading(false);
          $("#infoPopup").dxPopup("instance").option(
            "title",
            `Dettagli prenotazione di ${cellInfo.data.nome}`
          );
          $("#infoPopup").dxPopup("instance").option("contentTemplate", () => content);
          $("#infoPopup").dxPopup("instance").show();
  };

  return (
    <BounceIconButton
      icon={loading ? faSpinner : faCircleInfo}
       className={loading ? 'spin-icon' : ''}
      color="#46dbf2"
      onClick={loading ? null : handleClick}
    />
  );
}

async function mostraPopupInfoLezione(id,nome) {
  const allineamento="center"
  const camere_p = await funzione_collegamento({
    userid: getUserId(),
    token: getToken(),
    logout_on_error: true,
    azione:"getLinkBookingRooms",
    filtri: { bookingid: id,},
  });
  const extra_p=await funzione_collegamento({
    userid: getUserId(),
    token: getToken(),
    logout_on_error: true,
    azione:"getBookingExtras",
    filtri: { bookingid: id,},
  });
  let ospitiCamere=await funzione_collegamento({
    userid: getUserId(),
    token: getToken(),
    logout_on_error: true,
    azione:"getBookingGuests",
  });
  const div = document.createElement("div");
  div.style.padding = "0px";
  const titolo1=document.createElement("h2")
  titolo1.innerText="Informazioni prenotazione"
  titolo1.style.fontFamily = "Poppins, sans-serif";
  titolo1.style.marginBottom="0px"
  div.appendChild(titolo1)
  let contatore=0
  const titolo2=document.createElement("h3")

      titolo2.innerText="Extra"
      titolo2.style.fontFamily = "Poppins, sans-serif";
      titolo2.style.marginBottom="0px"
  if (extra_p.length!==0)
      div.appendChild(titolo2)
      if (extra_p.length!==0){
      const inner2=document.createElement("div");
      inner2.id = `gridContainerExtra`;

      div.appendChild(inner2);}
  setTimeout(() => {
  $(`#gridContainerExtra`).dxDataGrid({
            dataSource: extra_p,
            keyExpr: "extraid",
            columnAutoWidth: true,
          columnHidingEnabled: true,
            columns: [
              { dataField: "extratype", caption: "Tipo extra",hidingPriority:5,customizeText:function(e){
                return decodificaExtra(e.value)
              } },
              { dataField: "extravalue1",hidingPriority:4, caption: "Dettagli extra" },
              { dataField: "extracost",hidingPriority:3, caption: "Costo extra",calculateDisplayValue: function(rowData) {
          let val=0
          if (rowData.extracost)val=rowData.extracost
    return  `${val.toLocaleString("it-IT", { maximumFractionDigits: 2 })} ${convertiValuta(rowData.extracurrency)}`},},

              { dataField: "extracostus",hidingPriority:1, caption: "Costi associati",calculateDisplayValue: function(rowData) {
          let val=0
          if (rowData.extracostus)val=rowData.extracostus
    return  `${val.toLocaleString("it-IT", { maximumFractionDigits: 2 })} ${convertiValuta(rowData.extracostuscurrency)}`},},

              { dataField: "extrapaid",hidingPriority:2, caption: "Pagato",calculateDisplayValue: function(rowData) {
          let val=0
          if (rowData.extrapaid)val=rowData.extrapaid
    return  `${val.toLocaleString("it-IT", { maximumFractionDigits: 2 })} ${convertiValuta(rowData.extracurrency)}`},},
            ],
          })
  for (let camera of camere_p){
      const inner = document.createElement("div");
      inner.id = `gridContainerOspiti_${contatore}`;
      const titoloC=document.createElement("h3")
      titoloC.innerText=`${camera.roomdescr}. Costo: ${camera.linkbookroomcost} €, anticipo: ${camera.linkbookroomadvance} €`
      titoloC.style.fontFamily = "Poppins, sans-serif";
      titoloC.style.marginBottom="0px"
      div.appendChild(titoloC)
      div.appendChild(inner);


      const commento = document.createElement("p");
      let totale_ore=0
      let totale_ore_prog=0
      let ospitiCamera=[]
      for (let ospite of ospitiCamere){
        if (ospite.linkbookroomid===camera.linkbookroomid){
            ospitiCamera.push(ospite)
        }
      }
      let contatore2=0
  let ospitiGia=[]
  for (let ospite of ospitiCamera){
     ospitiGia.push({"id":contatore2,"luogoNascita":ospite.guestbirthplace,"dataNascita":ospite.guestbirthdate,"numeroPassaporto":ospite.guestdocnumber,"tipoDoc":ospite.guestdoctype,"guestid":ospite.guestid,"nome":ospite.guestname,"cognome":ospite.guestsurname,"nazionalita":ospite.guestnationality,"sesso":ospite.guestsex,"linkbookroomid":ospite.linkbookroomid})
    contatore2++
  }
        $(`#gridContainerOspiti_${contatore}`).dxDataGrid({
            dataSource: ospitiGia,
            keyExpr: "id",
            columnAutoWidth: true,
          columnHidingEnabled: true,
            columns: [
              { dataField: "nome", caption: "Nome",hidingPriority:7 },
              { dataField: "guestid", caption: "idCliente",visible:false },
              { dataField: "cognome",hidingPriority:8, caption: "Cognome" },
              { dataField: "luogoNascita",hidingPriority:4, caption: "Luogo di Nascita" },
              { dataField: "dataNascita",hidingPriority:5, caption: "Data di Nascita" },
              { dataField: "sesso", caption: "Genere",hidingPriority:1,customizeText: function (e) {
                if (e.value===0) return "Uomo"
                else return "Donna"
              }
              ,},
              { dataField: "nazionalita",hidingPriority:2, caption: "Nazionalità" },
              { dataField: "tipoDoc",hidingPriority:3, caption: "tipo Documento",
              customizeText: function (e) {
                if (e.value===1) return "Passaporto"
                else if (e.value===2) return "Carta d'identità"
                else return "Patente"
              },
              },
              { dataField: "numeroPassaporto",hidingPriority:6, caption: "Numero Documento" }
            ],
          })


    contatore+=1
    }

  }, 0);

  return div;
}

function BounceIconButton({ icon, onClick, color = "#000" }) {
  const [isClicked, setIsClicked] = useState(false);


  const handleClick = () => {
    setIsClicked(true);
    setTimeout(() => setIsClicked(false), 800);
    onClick();
  };

  return (
    <button
      style={{
        cursor: "pointer",
        padding: "5px",
        background: "none",
        border: "none",
        color: color,
      }}
      onClick={handleClick}
    >
      <FontAwesomeIcon icon={icon} className={isClicked ? "fa-bounce" : ""} />
    </button>
  );
}
const TabellaPrenotazioni = () => {
  const gridRef = useRef(null);
  const listinoPrezzi={"Base":{1:80,2:150,3:210,4:270,5:320,6:390,7:440,8:490,9:540,10:570},"Avanzata":{1:90,2:170,3:240,4:300,5:360,6:420,7:450,8:520,9:570,10:600},"Foil":{1:90,2:170,3:240,4:300,5:360,6:420,7:450,8:520,9:570,10:600}}
  const allineamento="center"
  useEffect(() => {
    const fetchPacchetti = async () => {
       $("#loadingOverlay").show();
      $("#gridContainer").addClass("grid-container-hidden")
      const data = await funzione_collegamento({
        userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        azione:'getBookings'
      });
      const formattedRows = data.map((row, index) => ({
        id: index,
        bookingid:row.bookingid,
        nome: row.bookingreference,
        checkin: convertDate(row.bookingcheckindate).toISO({ includeOffset: false }),
        checkout: convertDate(row.bookingcheckoutdate).toISO({ includeOffset: false }),
        note: row.bookingnotes,
        costo: row.bookingtotcost,
        anticipo: row.bookingadvancepaid,
        sconto:row.bookingdiscount,
        costo_scontato: (row.bookingtotcost * (1 - (row.bookingdiscount || 0) / 100)),
      }));
      // Inizializza dxDataGrid
      $("#gridContainer").dxDataGrid({
        dataSource: formattedRows,
        columns: [
          {
            dataField: "checkin",
            caption: "Data check-in",
            sortOrder: "desc",
             hidingPriority:4,
            alignment:allineamento,
            editCellTemplate: function (cellElement,cellInfo) {
          if ($("#val_reg").length===0) {
                $('<div id="val_reg"></div>').appendTo(cellElement)
            }
            $("#val_reg").dxDateBox({type:"date",format: "dd/MM/yyyy",displayFormat :"dd/MM/yyyy",value:cellInfo.value,onValueChanged: function(e) {
            if (e.value instanceof Date) {
              cellInfo.setValue(DateTime.fromJSDate(e.value).toISO({includeOffset:false}))
            }
            else {
                cellInfo.setValue(e.value)
            }
            }})
          },
            calculateFilterExpression: function(filterValue, selectedFilterOperation) {
              if (!filterValue) return null;
              if (selectedFilterOperation === "between" && Array.isArray(filterValue)) {
                const isoStart = DateTime.fromJSDate(filterValue[0]).toISO({ includeOffset: false });
                const isoEnd = DateTime.fromJSDate(filterValue[1]).toISO({ includeOffset: false });
                return [
                  [this.dataField, ">=", isoStart],
                  "and",
                  [this.dataField, "<=", isoEnd]
                ];
              }
              if (selectedFilterOperation === "<") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, "<=", isoStart]
              }
              if (selectedFilterOperation === ">") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, ">=", isoStart]
              }
              const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
              return [this.dataField, "=", isoStart]
            },
          customizeText: function(cellInfo) {
            if (typeof cellInfo.value==="string"){
                return DateTime.fromISO(cellInfo.value).toFormat("dd/MM/yyyy");
            }
            else {
                return DateTime.fromISO(DateTime.fromJSDate(cellInfo.value).toISO({ includeOffset: false })).toFormat("dd/MM/yyyy");
            }
          }
          },
          {
            dataField: "checkout",
            caption: "Data check-out",
             hidingPriority:3,
            alignment:allineamento,
            editCellTemplate: function (cellElement,cellInfo) {
          if ($("#val_reg_2").length===0) {
                $('<div id="val_reg_2"></div>').appendTo(cellElement)
            }
            $("#val_reg_2").dxDateBox({type:"date",format: "dd/MM/yyyy",displayFormat :"dd/MM/yyyy",value:cellInfo.value,onValueChanged: function(e) {
            if (e.value instanceof Date) {
              cellInfo.setValue(DateTime.fromJSDate(e.value).toISO({includeOffset:false}))
            }
            else {
                cellInfo.setValue(e.value)
            }
            }})
          },
            calculateFilterExpression: function(filterValue, selectedFilterOperation) {
              if (!filterValue) return null;
              if (selectedFilterOperation === "between" && Array.isArray(filterValue)) {
                const isoStart = DateTime.fromJSDate(filterValue[0]).toISO({ includeOffset: false });
                const isoEnd = DateTime.fromJSDate(filterValue[1]).toISO({ includeOffset: false });
                return [
                  [this.dataField, ">=", isoStart],
                  "and",
                  [this.dataField, "<=", isoEnd]
                ];
              }
              if (selectedFilterOperation === "<") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, "<=", isoStart]
              }
              if (selectedFilterOperation === ">") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, ">=", isoStart]
              }
              const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
              return [this.dataField, "=", isoStart]
            },
          customizeText: function(cellInfo) {
            if (typeof cellInfo.value==="string"){
                return DateTime.fromISO(cellInfo.value).toFormat("dd/MM/yyyy");
            }
            else {
                return DateTime.fromISO(DateTime.fromJSDate(cellInfo.value).toISO({ includeOffset: false })).toFormat("dd/MM/yyyy");
            }
          }
          },
          { dataField: "nome", caption: "Nome prenotazione", hidingPriority: 6,alignment:allineamento, },
          {
            dataField: "costo",
            caption: "Costo",
            alignment:allineamento,
            hidingPriority: 5,
            calculateDisplayValue: function(rowData) {
    return rowData.costo_scontato ?? rowData.costo;
  },
            editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_costo").length===0) {
                $('<div id="val_costo"></div>').appendTo(cellElement)
            }
            $("#val_costo").dxNumberBox({min:0,value:cellInfo.value,elementAttr: {
        inputmode: "decimal"   // forza tastiera con separatore decimale
    },format:"#0.##'€'", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            const sconto_att=$("#val_sconto").dxNumberBox("instance").option("value")
            $("#val_costo_scontato").dxNumberBox("instance").option("value",cellInfo.value*(1-sconto_att/100))

            }})
          },
            customizeText: function (e) {
              const val = typeof e.value === 'number' ? e.value : 0;
              return `${val.toFixed(2)} €`;
            }
          },
          {
            dataField: "anticipo",
            caption: "Anticipo",
            hidingPriority: 2,
            alignment:allineamento,
            editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_anticipo").length===0) {
                $('<div id="val_anticipo"></div>').appendTo(cellElement)
            }
            $("#val_anticipo").dxNumberBox({min:0,value:cellInfo.value,elementAttr: {
        inputmode: "decimal"   // forza tastiera con separatore decimale
    },format:"#0.##'€'", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            }})
          },
            customizeText: function (e) {
              const val = typeof e.value === 'number' ? e.value : 0;
              return `${val.toFixed(2)} €`;
            }
          },
          { dataField: "note", caption: "Note prenotazione", hidingPriority: 1,alignment:allineamento, },
          {dataField: "sconto",visible:false,editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_sconto").length===0) {
                $('<div id="val_sconto"></div>').appendTo(cellElement)
            }
            $("#val_sconto").dxNumberBox({showSpinButtons: true,step:5,min:0,elementAttr: {
        inputmode: "decimal"   // forza tastiera con separatore decimale
    },value:cellInfo.value,max:100,format:"#0.##'%'", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            const valore_nuovo=($("#val_costo").dxNumberBox("instance").option("value"))*(1-cellInfo.value/100)
            $("#val_costo_scontato").dxNumberBox("instance").option("value",valore_nuovo)
            }})
          }},
          {dataField: "costo_scontato",visible:false,
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_costo_scontato").length===0) {
                $('<div id="val_costo_scontato"></div>').appendTo(cellElement)
            }

            const displV=($("#val_costo").dxNumberBox("instance").option("value"))*(1-($("#val_sconto").dxNumberBox("instance").option("value"))/100)
            $("#val_costo_scontato").dxNumberBox({showSpinButtons: true,step:10,min:0,elementAttr: {
        inputmode: "decimal"   // forza tastiera con separatore decimale
    },value:displV,format:"#0.##'€'", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            $("#val_costo_scontato").dxNumberBox("instance").option("max",$("#val_costo").dxNumberBox("instance").option("value"))
            const valore_nuovo=(1-(e.value)/($("#val_costo").dxNumberBox("instance").option("value")))*100
            $("#val_sconto").dxNumberBox("instance").option("value",valore_nuovo)
            }})
          }
          },
          {
            type: "buttons",
            minWidth:140,
            buttons: [
              {
                hint: "Scarica Fattura",
                icon: "none",
                onClick: function (e) {
                  e.component.editRow(e.rowIndex);
                },
                template:  function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faFileArrowDown}
                      color="#007bff"
                      onClick={() => mostraOpzioni(cellInfo.data)}
                    />
                  );
                },
              },
              {
                hint: "Elimina",
                icon: "none",
                onClick: function (e) {
                  e.component.deleteRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faTrashCan}
                      color="#dc3545"
                      onClick={() => cellInfo.component.deleteRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },
                {
  hint: "Dettagli prenotazione",
  icon: "none",
  template: function (cellElement, cellInfo) {
    const root = ReactDOM.createRoot(cellElement.get(0));
    root.render(<DynamicLessonButton cellInfo={cellInfo} />);
  },
}
            ],
          },
        ],
        showBorders: true,
        scrolling:{
        useNative:true
        },
        rowAlternationEnabled: true,
        columnAutoWidth: true,
        paging: { pageSize: 50 },
        height: "100vh",
        width: "100%",
        columnHidingEnabled: true,
        searchPanel: {
          visible: true,
          width: 240,
          placeholder: 'Search...',
        },
        filterRow: {
          visible: true,
          applyFilter: 'auto',
        },
        editing: {
          mode: "popup",
          allowUpdating: false,
          allowAdding: false,
          allowDeleting: true,
          useIcons: true,
        },
        onCellClick: function(e) {
                if (e.event.target && e.event.target.classList.contains("dx-datagrid-adaptive-more")) {

  const masterRow = e.component.getRowElement(e.row.rowIndex);
  const $icon = masterRow.find(".dx-datagrid-adaptive-more.custom-icon-expanded");
  if (!($icon.length)) {
  const masterRow = e.component.getRowElement(e.row.rowIndex);
  const $icon = masterRow.find(".dx-datagrid-adaptive-more");
  if ($icon.length){
  $icon[0].className = "dx-datagrid-adaptive-more custom-icon-expanded";}
  }
  else
  {
  $icon[0].className = "dx-datagrid-adaptive-more";
  }}

},
    onEditorPreparing: function(e) {
  if (e.parentType === "filterRow" && e.dataField === "data") {

    e.editorName = "dxDateBox";  // Forza DateBox come filtro
    e.editorOptions = {
      displayFormat: "dd/MM/yyyy",
      type: "date",
      width: "100%",
      onValueChanged: function(ev) {
        e.setValue(ev.value);  // Applica il filtro
      }
    };
  }
},

    onInitNewRow: function (e) {
  e.data.costo = 0;
  e.data.anticipo=0
  e.data.data = DateTime.now().toISODate();
  e.data.tipo="Base"
  e.data.gruppoSingola=1
  e.data.sconto=0
  e.data.pacchetto=1
},
    onRowRemoving: async function (e) {
    const richiesta=  await funzione_collegamento({
       userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        delId:e.data.bookingid,
        azione:'delBooking',
        return_data:false})
    if (richiesta) {
        const message = `Prenotazione di ${e.data.nome} eliminato con successo`;
        window.DevExpress.ui.notify({message,
        position: {
          my: 'center',
          at: 'center',
          of: '#gridContainer',
        },}, "success", 1000);}


},


        onRowPrepared: function (e) {
            setTimeout(() => {
                $("#gridContainer").removeClass("grid-container-hidden");
                $("#loadingOverlay").hide();},500)
          if (e.rowType === "data" && e.rowElement && e.data) {
            const parseEuro = (val) =>
              parseFloat(String(val).replace("€", "").replace(",", ".").replace(/\s/g, ""));

            const anticipo = parseEuro(e.data.anticipo);
            const costo = parseEuro(e.data.costo_scontato);

            if (!isNaN(anticipo) && !isNaN(costo) && Math.abs(anticipo - costo) > 0.01) {
              e.rowElement.addClass("row-warning");
              $(e.rowElement).css("background-color", "#ffe6e6")
            }
          }
        },
      });
    };

    fetchPacchetti();
    $("#scaricaFile").dxPopup({
    width: "60%",
    height: 'auto',
    maxHeight:"90%",
    visible: false,
    dragEnabled: true,
    });
    $("#infoPopup").dxPopup({
    width: "80%",
    height: 'auto',
    maxHeight:"90%",
    visible: false,
    dragEnabled: true,
    closeOnOutsideClick: true,
    showCloseButton: true,
    onShown: function(e) {
    const $content = $(e.component.content());
    const $scroll = $("#customScroll");

    if ($scroll.length) {
        if ($scroll.data("dxScrollView")) {
            $scroll.dxScrollView("instance").dispose();
        }
        $scroll.remove();
    }

    $content.wrapInner('<div id="customScroll" style="height: 100%;"></div>');
    $("#customScroll").dxScrollView({
        useNative: true,
        direction: "vertical",
        showScrollbar: "onScroll"
    });
}

});

  }, []);

  return (

    <div id="gridContainer" ref={gridRef}></div>
  );
}
return (<div id="app" style={{ padding: "0px" }}>

    <TabellaPrenotazioni />
    <div id="scaricaFile" />
    <div style={{padding:"30px"}} id="infoPopup">
      <div className="popup-content">
      </div>
    </div>
    <div id="loadingOverlay">
      <div className="spinner">
        <Lottie  style={{ width: "100%", height: "100%" }} animationData={animLoading2} loop={true} />
      </div>
    </div>
  </div>)
}

export default PaginaPrenotazioni;
